import { Transforms, Editor, Element as SlateElement, Range, Path } from 'slate';

export default function withMentions(editor) {

  const { deleteBackward } = editor;

  editor.deleteBackward = function _deleteBackward(unit) {

    const { selection } = editor;
    
    if (selection && Range.isCollapsed(selection)) {

      const [match] = Editor.nodes(editor, {
        match(node) {

          if (Editor.isEditor(node) === true) {
            return false;
          }

          if (SlateElement.isElement(node) === false) {
            return false;
          }

          return node.type === 'mention';
        }
      });

      if (match) {
        const [, path] = match;

        return Transforms.removeNodes(editor, {
          match(node, nodePath) {
            return Path.equals(path, nodePath);
          }
        });
      }

    }

    deleteBackward(unit);

  };

  return editor;

}